<template>
  <div class="pt-1">

    <v-btn
      small
      depressed
      class="teal lighten-1 white--text"
      @click.native.stop="startDialog"
    >
      <v-icon class="caption">add</v-icon> &nbsp;
        {{$t('organizations.button-add-pc')}}
    </v-btn>

  <v-dialog
    id="organization-add"
    v-model="showAddDialog"
    max-width="400px"
    persistent
  >
    <!--組織追加ダイアログ コンテンツ-->
    <v-card class="pa-2">

      <div v-if="errorMessage" class="red--text" >
        <strong>{{errorMessage}}</strong>
      </div>

      <v-form
        v-model="validated"
        ref="addOrganizationPcForm"
        >

        <!-- 基本情報 -->
        <div class="ma-3 mb-5">
          <p>{{$t("account.label-organization")}}</p>
          <v-text-field
            :label="$t('account.organization')"
            v-model="edit.name"
            required
            :rules="[v => !!v || $t('account.vali-org-name')]"
          ></v-text-field>

          <v-text-field
            :label="$t('account.description')"
            v-model="edit.description"
          ></v-text-field>

          <v-text-field
            :label="$t('account.incharge')"
            v-model="edit.contact"
          ></v-text-field>

          <v-text-field
            :label="$t('account.tel')"
            :rules="phoneRules"
            v-model="edit.phone"
          ></v-text-field>

          <v-text-field
            :label="$t('account.email')"
            :rules="emailRules"
            v-model="edit.email"
          ></v-text-field>

          <v-select
            :label="$t('aplix-use-only.customer-category')"
            v-model="edit.customerCategoryId"
            :items="customerCategories"
            item-text="name"
            item-value="customerCategoryId"
            :rules="[v => !!v || $t('validate.select')]"
            required
            auto
          ></v-select>

        </div>
        <!-- 組織作成制限 -->
        <div class="ma-3">
          <p>{{$t("organizations.limit-settings")}}</p>
          <v-checkbox
            :label="$t('organizations.no-limit')"
            v-model="edit.createNoLimit"
          ></v-checkbox>

        </div>
        <div class="ma-3">
          <p>{{$t("account.label-account")}}</p>
          <v-text-field
            required
            :label="$t('account.username')"
            v-model="edit.username"
            :rules="[v => !!v || $t('account.vali-username-must')]"
          ></v-text-field>

          <v-text-field
            required
            :label="$t('account.useremail')"
            v-model="edit.useremail"
            :rules="useremailRules"
          ></v-text-field>
        </div>

        <v-layout justify-center>

          <v-btn
            v-if="userRole!==rootRoleName"
            flat
            @click.native="closeDialog"
          >
            {{$t('account.cancel')}}
          </v-btn>

          <v-btn
            v-else
            flat
            @click.native="closeDialog"
          >
            {{$t('account.close')}}
          </v-btn>

          <v-btn
            v-if="userRole===rootRoleName"
            color="primary"
            class="ml-4"
            @click="addOrganizationPc"
            :disabled="btnDisable||!validated"
          >
            {{$t("account.create")}}
          </v-btn>

        </v-layout>
      </v-form>
    </v-card>

  </v-dialog>
  </div>
</template>

<script>
import config from '@/config.js'
import http from '@/utils/http.js'
import utils from '@/utils/utils.js'
import validate from '@/utils/validate.js'

export default {
  data () {
    return {
      organizations: [],
      configLimitCreateHierarchy: config.organizationConfig.limitCreateHierarchy,
      userRole: this.$store.getters.user.roles[0]['name'],
      rootRoleName: config.role.Root,
      customerCategories: [],
      edit: {
        organization: '',
        parOrganization: '',
        name: '',
        contact: '',
        description: '',
        startDate: '',
        phone: '',
        email: '',
        username: '',
        useremail: '',
        limitCreateHierarchy: 0,
        createNoLimit: false,
        customerCategoryId: 0
      },
      showAddDialog: false,
      validated: true,
      btnDisable: false,
      errorMessage: '',
      // rule
      emailRules: [
        v => validate.emailFormat(v) ||
           this.$t('account.vali-email-format')
      ],
      phoneRules: [
        v => validate.phoneFormat(v) ||
           this.$t('account.vali-phone-format'),
        v => v.length <= 128 || this.$t('account.vali-phone-length')
      ],
      useremailRules: [
        v => !!v || this.$t('account.vali-email-must'),
        v => validate.emailFormat(v) ||
           this.$t('account.vali-email-format')
      ]
    }
  },
  methods: {
    init () {
      this.getCustomerCategories()
    },
    getCustomerCategories () {
      http.request('get', '/service2/dashboard/api/CustomerCategories/customerCategoryList')
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get customerCategories list failed. (' + data.result + ')')
            return
          }
          this.customerCategories = utils.setNameCustomerCategories(this.$t, data.customerCategories)
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
        })
    },
    startDialog (param) {
      this.errorMessage = ''
      this.showAddDialog = true
      this.edit.description = param.description
      this.edit.name = param.name
      this.edit.username = param.username
      this.edit.useremail = param.useremail
      this.edit.contact = param.contact
      this.edit.phone = param.phone
      this.edit.email = param.email
      this.edit.limitCreateHierarchy = param.limitCreateHierarchy
      this.edit.customerCategoryId = parseInt(param.customer_category_id)
      this.$refs.addOrganizationPcForm.reset()
      // 初期値に無限大を設定
      this.edit.createNoLimit = true
    },
    addOrganizationPc () {
      const self = this
      const params = {
        organizationName: this.edit.name,
        contact: this.edit.contact,
        phone: this.edit.phone,
        organizationEmail: this.edit.email,
        description: this.edit.description,
        username: this.edit.username,
        useremail: this.edit.useremail,
        generatedUuid: utils.generateUuid(),
        limitCreateHierarchy: this.setLimitCreateHierarchy(),
        customerCategoryId: this.edit.customerCategoryId
      }
      console.log(params)
      http.request('post', '/service2/dashboard/api/Organizations/registerPc', params)
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            switch (data.result) {
              case -102:
                self.showError(self.$t('account.fail-username'))
                break
              default:
                self.showError('server error')
            }
          } else {
            this.$emit('reload')
            this.closeDialog()
          }
        })
        .catch(error => {
          console.log('error', error)
        })
    },
    setLimitCreateHierarchy () {
      var limitCreateHierarchy = this.configLimitCreateHierarchy.min
      if (this.edit.createNoLimit === true) {
        limitCreateHierarchy = this.configLimitCreateHierarchy.max
      }
      return limitCreateHierarchy
    },
    closeDialog () {
      this.btnDisable = false
      this.showAddDialog = false
    },
    showError (error) {
      this.errorMessage = error
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style>
.dialog__container {
  width: 100%;
}
#organization-add .btn__content {
  /* justify-content: left; */
}
</style>



// WEBPACK FOOTER //
// AccountOrganizationPcAdd.vue?79b1e5d8